import React from 'react';
import { Link, useParams } from 'react-router-dom';

interface NavItemProps {
  to: string;
  active?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

const NavItem: React.FC<NavItemProps> = ({
  to,
  active,
  children,
  onClick,
  className = ''
}) => {
  const { lang } = useParams<{ lang: string }>();
  
  // Ensure the link includes the language prefix
  const getLanguagePrefixedPath = (path: string) => {
    // If path already starts with a language code, don't modify it
    if (/^\/[a-z]{2}(\/|$)/.test(path)) {
      return path;
    }
    
    // Don't add language prefix to admin routes
    if (path.startsWith('/admin')) {
      return path;
    }
    
    // If path is root, just return the language prefix
    if (path === '/') {
      return `/${lang || 'en'}`;
    }
    
    // Otherwise, add the language prefix
    return `/${lang || 'en'}${path.startsWith('/') ? path : `/${path}`}`;
  };
  
  const baseStyles = "text-gray-700 font-semibold px-6 py-2 rounded-[1rem] transition-all duration-200 hover:bg-primary-50 hover:text-primary";
  const activeStyles = active ? "bg-primary-50 text-primary" : "";
  const combinedStyles = `${baseStyles} ${activeStyles} ${className}`;

  return (
    <Link 
      to={getLanguagePrefixedPath(to)}
      className={combinedStyles}
      onClick={onClick}
    >
      <span>{children}</span>
    </Link>
  );
};

export default NavItem;